enum TransactionAmountFilterType {
  TransactionAmount = "TransactionAmount",
  OutstandingAmount = "OutstandingAmount",
}

export default TransactionAmountFilterType;
